function sanitizeSlug(slug) {
  return String(slug || "").replace(/[^-0-9a-z]/g, "");
}

function getRewardsDomain() {
  return process.env.REWARDS_DOMAIN || window.rewardsDomain || "";
}

function getRewardsBaseUrl() {
  const base = process.env.REWARDS_URL || window.rewardsUrl || "http://localhost:3001";

  return base.replace(/\/+$/, "");
}

export function buildRewardsPlaceUrl(slug, { preview = false } = {}) {
  const safeSlug = sanitizeSlug(slug);

  if (!safeSlug) {
    return "";
  }

  const rewardsDomain = getRewardsDomain();
  let url;

  if (rewardsDomain) {
    url = new URL("https://" + safeSlug + "." + rewardsDomain.replace(/^\.+/, "") + "/");
  } else {
    url = new URL(getRewardsBaseUrl() + "/");
    url.searchParams.set("place", safeSlug);
  }

  if (preview) {
    url.searchParams.set("preview", "1");
  }

  return url.toString();
}

export function getRewardsOrigin(url) {
  try {
    return new URL(url).origin;
  } catch (error) {
    return "";
  }
}
